export const WORK_CHAIN = +Number(process.env.REACT_APP_CHAIN_ID || 84532)

export const BASE_SCAN = process.env.REACT_APP_SCAN_URL

export const RPC_BASE_URL = process.env.REACT_APP_RPC_URL

export const RPC_PUBLIC_URL = process.env.REACT_APP_RPC_PUBLIC_URL

export const WEB3_PROVIDER = process.env.REACT_APP_WEB3_PROVIDER

export const ENABLE_TESTNET = process.env.REACT_APP_ENABLE_TESTNET === 'true'

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || ''

export const SAFE_API_KEY = process.env.REACT_APP_SAFE_API_KEY || ''

/** Web user (Next.js) origin, no trailing slash — used to revalidate its cached pages. */
export const WEB_USER_URL = process.env.REACT_APP_WEB_USER_URL || ''

export const DEFAULT_POSITION = {
  LAT: 10.762622,
  LNG: 106.660172,
}

export const SESSION_KEY = {
  TOKEN: 'token',
  USER: 'userName',
}

export const enum ContractStatusEnum {
  PENDING = 'pending',
  SUCCESS = 'success',
  REVERTED = 'reverted',
  ERROR = 'error',
}

export const CONFIRMATIONS_BLOCK = +(process.env.REACT_APP_CONFIRMATIONS_BLOCK || 1)
